import React, { useState } from 'react';
import './Trainings.css';

function Trainings() {
  const [activeFilter, setActiveFilter] = useState('All');

  const trainings = [
    {
      id: 1,
      title: 'Reiki Level 1 Attunement',
      description: 'Begin your journey into Reiki healing. Receive your first attunement and learn the fundamentals of channeling universal life force energy.',
      duration: '2 hours',
      price: '$150',
      type: 'On-Call Session',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop&auto=format',
      category: 'On-Call Attunement Sessions'
    },
    {
      id: 2,
      title: 'Chakra Alignment Guide',
      description: 'Comprehensive PDF guide with detailed information about the seven chakras, their meanings, and practices for alignment and balance.',
      duration: 'PDF Guide',
      price: '$45',
      type: 'PDF / Audio',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop&auto=format',
      category: 'PDF / Audio Only'
    },
    {
      id: 3,
      title: 'Reiki Level 2 Attunement',
      description: 'Deepen your Reiki practice with advanced techniques and symbols. Learn distance healing and emotional healing methods.',
      duration: '3 hours',
      price: '$200',
      type: 'On-Call Session',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop&auto=format',
      category: 'On-Call Attunement Sessions'
    },
    {
      id: 4,
      title: 'Meditation & Mindfulness Audio Collection',
      description: 'A curated collection of guided meditation audio sessions designed to bring peace, clarity, and spiritual connection into your daily practice.',
      duration: '5 Audio Sessions',
      price: '$60',
      type: 'PDF / Audio',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&h=400&fit=crop&auto=format',
      category: 'PDF / Audio Only'
    },
    {
      id: 5,
      title: 'Energy Protection & Clearing Techniques',
      description: 'Learn essential techniques for protecting your energy field and clearing negative or stagnant energy. Includes practical exercises and visualizations.',
      duration: 'PDF Guide + Audio',
      price: '$55',
      type: 'PDF / Audio',
      image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=400&fit=crop&auto=format',
      category: 'PDF / Audio Only'
    },
    {
      id: 6,
      title: 'Reiki Master Attunement',
      description: 'Complete your Reiki journey with the Master level attunement. Receive advanced symbols and learn to attune others to Reiki energy.',
      duration: '4 hours',
      price: '$350',
      type: 'On-Call Session',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop&auto=format',
      category: 'On-Call Attunement Sessions'
    }
  ];

  const filteredTrainings = activeFilter === 'All' 
    ? trainings 
    : trainings.filter(training => training.category === activeFilter);

  return (
    <div className="trainings-page">
      {/* Page Header */}
      <section className="trainings-header">
        <div className="container">
          <h1 className="trainings-page-title">Trainings & Attunements</h1>
          <p className="trainings-subtitle">
            Deepen your spiritual practice through comprehensive training programs and attunement sessions. 
            Choose from self-paced guides or personalized on-call sessions with experienced practitioners.
          </p>
        </div>
        <div className="wave-divider"></div>
      </section>

      {/* Training Filters */}
      <section className="trainings-filters-section">
        <div className="container">
          <div className="training-filter-tabs">
            <button 
              className={`training-filter-tab ${activeFilter === 'All' ? 'active' : ''}`}
              onClick={() => setActiveFilter('All')}
            >
              All
            </button>
            <button 
              className={`training-filter-tab ${activeFilter === 'PDF / Audio Only' ? 'active' : ''}`}
              onClick={() => setActiveFilter('PDF / Audio Only')}
            >
              PDF / Audio Only
            </button>
            <button 
              className={`training-filter-tab ${activeFilter === 'On-Call Attunement Sessions' ? 'active' : ''}`}
              onClick={() => setActiveFilter('On-Call Attunement Sessions')}
            >
              On-Call Attunement Sessions
            </button>
          </div>
        </div>
      </section>

      {/* Training Cards Grid */}
      <section className="trainings-grid-section">
        <div className="container">
          {filteredTrainings.length > 0 ? (
            <div className="trainings-grid">
              {filteredTrainings.map((training) => (
                <div key={training.id} className="training-card">
                  <div className="training-image-wrapper">
                    <img 
                      src={training.image} 
                      alt={training.title}
                      className="training-card-image"
                    />
                    <div className="training-type-badge">
                      {training.type}
                    </div>
                    <div className="training-gradient-overlay"></div>
                  </div>
                  <div className="training-card-content">
                    <h3 className="training-card-title">{training.title}</h3>
                    <p className="training-description">{training.description}</p>
                    <div className="training-meta">
                      <span className="training-duration-badge">{training.duration}</span>
                      <span className="training-price-badge">{training.price}</span>
                    </div>
                    <div className="training-actions">
                      <button className="btn-view-details-training">
                        View Details
                      </button>
                      {training.type === 'On-Call Session' && (
                        <button className="btn-book-attunement">
                          Book Attunement Session
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="trainings-empty-state">
              <div className="empty-state-illustration">
                <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#20B2AA" stopOpacity="0.6"/>
                      <stop offset="50%" stopColor="#1E3A8A" stopOpacity="0.6"/>
                      <stop offset="100%" stopColor="#7C3AED" stopOpacity="0.6"/>
                    </linearGradient>
                  </defs>
                  <path d="M20,100 Q50,50 100,100 T180,100" stroke="url(#waveGradient)" strokeWidth="3" fill="none" opacity="0.8"/>
                  <path d="M20,120 Q50,70 100,120 T180,120" stroke="url(#waveGradient)" strokeWidth="3" fill="none" opacity="0.6"/>
                  <path d="M20,140 Q50,90 100,140 T180,140" stroke="url(#waveGradient)" strokeWidth="3" fill="none" opacity="0.4"/>
                  <circle cx="100" cy="100" r="30" fill="url(#waveGradient)" opacity="0.3"/>
                  <circle cx="100" cy="100" r="15" fill="url(#waveGradient)" opacity="0.5"/>
                </svg>
              </div>
              <h3 className="empty-state-title">More Trainings Coming Soon</h3>
              <p className="empty-state-text">
                We're continuously expanding our training offerings. Check back soon for new attunements and guides.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Gentle Closure with Wave Fade */}
      <section className="trainings-footer">
        <div className="wave-footer-fade"></div>
      </section>
    </div>
  );
}

export default Trainings;
